import { useMutation } from '@tanstack/react-query';
import { HeapService } from '../../generated';

interface TriggerCaptureProps {
  jobsiteId: string;
}

export function useTriggerCapture() {
  return useMutation({
    mutationFn: async ({ jobsiteId }: TriggerCaptureProps) =>
      HeapService.heapControllerTriggerHeapCapture({ path: { jobsiteId } }),
  });
}
